import io from "socket.io-client";

class serverConnect {
    constructor() {
        this.socket = undefined;
    }

    connect() {
        if (this.socket === undefined) {
            console.log("create connection");
            this.socket = io.connect();
        }
        return this.socket;
    }

    on(event, fn) {
        return this.connect().on(event, fn);
    }

    emit(event, ...args) {
        return this.connect().emit(event, args);
    }
}

export default new serverConnect();
